/**
 * Created by luliangxiao on 16/12/24.
 */
module.exports = {
  SERVICE_NAME: '', // service name
  DEV_DOMAIN: 'http://idg-' + 'w11p3333 <applecatkay@gmail.com>' + '.tunnel.nibaguai.com/', // TO FILL IN YOUR DOMAIN
  DEV_USER_INFO: {
    appkey: 'rjtwfgeqm2ankhx91wcp3hkeycujiutl',
    channel: '1',
    account_id: 'dev',
    nickname: 'w11p3333 <applecatkay@gmail.com>'
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/dev.consts.js
// module id = 34
// module chunks = 4